import languageExtra from "./languageExtra";

const language = {
  geo: {
    header: {
      main: "მთავარი",
      about_us: "ჩვენს შესახებ",
      market: "მარკეტი",
      our_services: ["ჩვენი", "სერვისები"],
      contact: "კონტაქტი",
      login: "შესვლა",
      logout: "გასვლა"
    },
    cars:{
      title: "მანქანები",
      filterByMark: "ფილტრი ბრენდის მიხედვით",
      filterByModel: "ფილტრი მოდელის მიხედვით",
      searchByKeyword: "ძებნა საკვანძო სიტყვით",
    },
    home_page: {
      banner_main_text: "შეცვალე ძველი - ახლით!",
      banner_small_text: "* პრემიუმ",
      banner_main_slogan: "გადაზიდვა აშშ-დან მსოფლიოს მასშტაბით - ყველაზე სწრაფად და ხელმისაწვდომ ფასად",
      banner_subtext: "CAREXPRESS შენი გზა - სანდო ავტომობილისკენ!",
      divided_banner_title: "",
      divided_banner_description: "20 წლიანი გამოცდილების ხარჯზე ქარექსპრესი ერთ-ერთი ყველაზე მსხვილი ლიცენზირებული ავტო-იმპორტიორია კავკასიაში. რაც კომპანიას საშუალებას აძლევს მონაწილეობა მიიღოს მსოფლიოს წამყვან საავტომობილო აუქციონებზე. <br /> კომპანია ახორციელებს ავტომობილებისა და ნებისმიერი ტიპის სპეც-ტექნიკის, ასევე, ავტონაწილებისა და აქსესუარების იმპორტს ამერიკიდან, კანადიდან და ევროპიდან.",
      divided_banner_description2: [`
        &nbsp&nbsp&nbspქარექსპრესი 20 წლიანი გამოცდილების ხარჯზე ერთ-ერთი ყველაზე მსხვილი ლიცენზირებული ავტო-იმპორტიორია კავკასიაში, რაც საშუალებას აძლევს მონაწილეობა მიიღოს მსოფლიოს წამყვან საავტომობილო აუქციონებზე.
        <br /> &nbsp&nbsp&nbspკომპანია ახორციელებს ავტომობილებისა და ნებისმიერი ტიპის სპეც-ტექნიკის, ასევე, ავტონაწილებისა და აქსესუარების იმპორტს ამერიკიდან, ევროპიდან და კანადიდან.
        <br /> &nbsp&nbsp&nbspქარექსპრესის მომხმარებლებს შეუძლიათ ისარგებლონ მათ ინტერესზე მორგებული, ინოვაციური სერვისებით, როგორც ავტომობილის ერთჯერადად შეძენის, ასევე, ავტო-იმპორტის ბიზნესით დაინტერესების შემთხვევაში.
        <br /> &nbsp&nbsp&nbspკომპანია დაარსების დღიდან, მისი განვითარების პერიოდში, დაკომპლექტდა მაღალკვალიფიციური გუნდით და დღეს უკვე საქართველოს მასშტაბით 30-მდე ფილიალს და საქართველოს ფარგლებს გარეთ 10-მდე წარმომადგენლობას ითვლის როგორც ამერიკაში, ასევე, ყირგიზეთსა და არაბთა გაერთიანებულ საამიროებში.
        <br /> &nbsp&nbsp&nbspქარექსპრესის მიერ იმპორტირებული ავტომობილების რაოდენობა ამჟამად უკვე 200 000-ს აჭარბებს.
        `, `
        <br /><br /> &nbsp&nbsp&nbspდაინტერესებულ პირებს ჩვენ ვთავაზობთ:
        <br />•	შეუზღუდავ არჩევანს მსოფლიოს წამყვან აუქციონებსა და სადილერო მარკეტებზე.
        <br />•	ავტომობილის შეძენას საუკეთესო ფასად. 
        <br />•	უსაფრთხო და სწრაფ ტრანსპორტირებას.
        <br />•	შერჩეულ ავტომობილზე თანადაფინანსების მოქნილ და ინდივიდუალურად კლიენტზე მორგებულ პირობებს.
        <br />•	ავტომობილის დაზიანების პასუხისმგებლობას.
        <br />•	ტრანსპორტირებას შეძენის ადგილიდან, თქვენთვის სასურველ პუნქტამდე.
        <br />•	ავტომობილის რეალიზაციაში დახმარებას.
        <br />•	სატერმინალო მომსახურებას.
        `, `
        <br /><br /> &nbsp&nbsp&nbsp2020 წლიდან კლიენტებისათვის მეტი ხელშეწყობისა და კომფორტული პირობების შესაქმნელად კომპანიამ საერთაშორისო სტანდარტებზე მორგებული „ავტო-მარკეტი“ გახსნა ქალაქ რუსთავში, ავტობაზრობის ტერიტორიაზე. 
        <br /> &nbsp&nbsp&nbspქარექსპრესის ავტო-მარკეტი უკვე უამრავი კლიენტისათვის იქცა მოსახერხებელ და პრაქტიკულ ლოკაციად — სადაც თავმოყრილია გამარტივებული პროცესები, კომფორტული გარემო და სწრაფი სერვისი ერთ სივრცეში.
        <br /> &nbsp&nbsp&nbspკომპანია ასევე, წარმოდგენილია საკუთარი ტერმინალით, რომელიც მუდმივად ემსახურება ადგილობრივ და რეგიონულ კლიენტებს. 
        <br /> &nbsp&nbsp&nbspქარექსპრესი წლების განმავლობაში დაგროვილ გამოცდილებას მუდმივად იყენებს ლოჯისტიკური უნარებისა და მომსახურების ხარისხის გასაუმჯობესებლად. შესაბამისად, ჩვენს კლიენტებს ყოველთვის ვთავაზობთ სწრაფ, ხარისხიან და უსაფრთხო გადაადგილებებს როგორც შიდა - სახმელეთო გზით, ასევე, საზღვაო ტრანსპორტირებისას. 
        <br /> &nbsp&nbsp&nbspკომპანია დაკომპლექტებულია გუნდით, რომელიც მუდამ მზად არის დაეხმაროს და აამაღლოს კლიენტის ცნობადობა მიმდინარე პროცესების შესახებ და აქციოს ის მათთვის სრულიად გამჭვირვალედ.
      `],
      divided_banner_bullet_1: "წყლის ტრანსპორტი",
      divided_banner_bullet_2: "მანქანები / მოტოციკლები / ATV",
      divided_banner_bullet_3: "მძიმე ტექნიკა",
      check_more: "შეამოწმე მეტი",
      what_we_do: "რას ვაკეთებთ?",
      services_title: ["ჩვენი", "სერვისები"],
      sea_cargo: "საზღვაო ტვირთი",
      air_cargo: "საჰაერო ტვირთი",
      yacht: "იახტების ტრანსპორტირება",
      any_question: "რაიმე კითხვა გაქვთ?",
      any_question_detailed: "",
      import_now: "ჩამოიყვანე ახლა",
      call_us: "დაგვირეკეთ",
      write_us: "მოგვწერეთ",
      address: "მისამართი",
      our_address: "თბილისი, გურამ ფანჯიკიძის ქ 22"
    },
    contact: {
      password: "პაროლი",
      email_us: "მოგვწერეთ",
      our_address: "ჩვენი მისამართია",
      address: "თბილისი, გურამ ფანჯიკიძის ქ 22",
      opening_hours: "სამუშაო საათები",
      hours: "ორშ - პარ / 10:00 - 19:00",
      call_us: "დაგვიკავშირდით",
      get_in_touch: "დაგვიკავშირდით",
      location: "მდებარეობა",
      name: "სახელი",
      name_placeholder: "ჩაწერეთ თქვენი სახელი",
      email: "ელ-ფოსტა",
      email_placeholder: "ჩაწერეთ თქვენი ელ-ფოსტა",
      number: "ნომერი",
      subject: "საკითხი",
      message: "შეტყობინება",
      number_placeholder: "ჩაწერეთ თქვენი ნომერი",
      subject_placeholder: "ჩაწერეთ საკითხი",
      message_placeholder: "ჩაწერეთ შეტყობინება",
      send_message: "შეტყობინების გაგზავნა",
      loading: "იგზავნება..."
    },
    footer: {
      footer_sublogo_slogan: "",
      footer_subscribe_description: "გსურთ, მიიღოთ შეტყობინებები ჩვენი სერვისების შესახებ. უბრალოდ დარეგისტრირდით და ჩვენ გამოგიგზავნით შეტყობინებას ელექტრონული ფოსტით.",
      email: "ელ-ფოსტის მისამართი",
      rights: "©2025 Carexoress. ყველა უფლება დაცულია.",
      quick_links: "სწრაფი ბმულები",
      subscribe: "გამოწერა",
      subsubscribe: "გსურთ, მიიღოთ შეტყობინებები ჩვენი სერვისების შესახებ. უბრალოდ დარეგისტრირდით და ჩვენ გამოგიგზავნით შეტყობინებას ელექტრონული ფოსტით."
    },
    login: {
      user: "ელ-ფოსტა",
      password: "პაროლი"
    },
    details: {
      share: "გაზიარება",
      price: "ფასი",
      sold: "გაყიდულია",
      for_sale: "იყიდება",
      additional_info: "დამატებითი ინფორმაცია",
      mark: "ბრენდი",
      model: "მოდელი",
      year: "წელი",
      category: "კატეგორია",
      engine: "ძრავი",
      millage: "გარბენი",
      color: "ფერი",
      transmission: "გადაცემათა კოლოფი",
      fuel_type: "საწვავი",
      drive_type: "წამყვანი თვლები",
      cilinders: "ცილინდრები",
      gear_box: "გადაცემათა კოლოფი",
      location: "მდებარეობა",
      vin: "VIN",
      doors: "კარები",
      airbags: "აირბეგები",
    }
  },
  en: {
    header: {
      main: "Home",
      about_us: "About Us",
      market: "Market",
      our_services: ["Our", "Services"],
      contact: "Contact",
      login: "Login",
      logout: "Logout"
    },
    cars:{
      title: "Cars",
      filterByMark: "Filter By Brand",
      filterByModel: "Filter By Model",
      searchByKeyword: "Search By Keyword",
    },
    home_page: {
      banner_main_text: "Replace the old - with the new!",
      banner_small_text: "* Premium",
      banner_main_slogan: "Shipping from the USA worldwide - fastest and at the best price",
      banner_subtext: "CAREXPRESS your way - to a reliable car!",
      divided_banner_title: "",
      divided_banner_description: "With 20 years of experience, Carexpress is one of the largest licensed auto importers in the Caucasus, allowing the company to participate in the world's leading automotive auctions. <br /> The company imports vehicles, all types of special equipment, as well as auto parts and accessories from the United States, Canada, and Europe.",
      divided_banner_description2: [`
        &nbsp&nbsp&nbspWith 20 years of experience, Carexpress is one of the largest licensed auto importers in the Caucasus, which allows it to participate in the world's leading automotive auctions.
        <br /> &nbsp&nbsp&nbspThe company imports vehicles, all types of special equipment, as well as auto parts and accessories from the United States, Europe, and Canada.
        <br /> &nbsp&nbsp&nbspCarexpress customers can benefit from tailored, innovative services, whether for a one-time car purchase or for those interested in the auto-import business.
        <br /> &nbsp&nbsp&nbspSince its founding, the company has built a highly qualified team during its development, and today it has around 30 branches throughout Georgia and about 10 representatives abroad — in the USA, Kyrgyzstan, and the United Arab Emirates.
        <br /> &nbsp&nbsp&nbspThe number of vehicles imported by Carexpress has now exceeded 200,000.
      `, `
        <br /><br /> &nbsp&nbsp&nbspWe offer interested parties:
        <br />•	Unlimited selection from leading auctions and dealership markets worldwide.
        <br />•	Purchase of a car at the best price.
        <br />•	Safe and fast transportation.
        <br />•	Flexible and individually tailored co-financing options for the selected vehicle.
        <br />•	Liability for vehicle damage.
        <br />•	Transportation from the point of purchase to your desired destination.
        <br />•	Assistance in vehicle resale.
        <br />•	Terminal services.
      `, `
        <br /><br /> &nbsp&nbsp&nbspSince 2020, to better support customers and create convenient conditions, the company opened an international standard "Auto Market" in Rustavi, on the auto market territory.
        <br /> &nbsp&nbsp&nbspCarexpress's Auto Market has already become a convenient and practical location for many customers — bringing simplified processes, a comfortable environment, and fast service into one space.
        <br /> &nbsp&nbsp&nbspThe company also operates its own terminal, which continuously serves local and regional clients.
        <br /> &nbsp&nbsp&nbspCarexpress constantly applies its years of experience to improve its logistics skills and service quality. As a result, we always offer our clients fast, high-quality, and safe transport — both via land and sea.
        <br /> &nbsp&nbsp&nbspThe company is staffed with a team that is always ready to assist and increase client awareness of current processes, making everything fully transparent.
      `],
      divided_banner_bullet_1: "Water Transport",
      divided_banner_bullet_2: "Cars / Motorcycles / ATV",
      divided_banner_bullet_3: "Heavy Machinery",
      check_more: "Check more",
      what_we_do: "What do we do?",
      services_title: ["Our", "Services"],
      sea_cargo: "Sea Cargo",
      air_cargo: "Air Cargo",
      yacht: "Yacht Transportation",
      any_question: "Any questions?",
      any_question_detailed: "",
      import_now: "Import Now",
      call_us: "Call Us",
      write_us: "Write to Us",
      address: "Address",
      our_address: "Tbilisi, Guram Panjikidze St. 22"
    },
    contact: {
      password: "Password",
      email_us: "Email Us",
      our_address: "Our address is",
      address: "Tbilisi, Guram Panjikidze St. 22",
      opening_hours: "Opening Hours",
      hours: "Mon - Fri / 10:00 - 19:00",
      call_us: "Call Us",
      get_in_touch: "Get in Touch",
      location: "Location",
      name: "Name",
      name_placeholder: "Enter your name",
      email: "Email",
      email_placeholder: "Enter your email",
      number: "Phone Number",
      subject: "Subject",
      message: "Message",
      number_placeholder: "Enter your phone number",
      subject_placeholder: "Enter the subject",
      message_placeholder: "Enter your message",
      send_message: "Send Message",
      loading: "Sending..."
    },
    footer: {
      footer_sublogo_slogan: "",
      footer_subscribe_description: "Want to receive updates about our services? Just subscribe and we’ll send you notifications via email.",
      email: "Email Address",
      rights: "©2025 Carexpress. All rights reserved.",
      quick_links: "Quick Links",
      subscribe: "Subscribe",
      subsubscribe: "Want to receive updates about our services? Just subscribe and we’ll send you notifications via email."
    },
    login: {
      user: "Email",
      password: "Password"
    },
    details: {
      share: "Share",
      price: "Price",
      sold: "Sold",
      for_sale: "For Sale",
      additional_info: "Additional Information",
      mark: "Brand",
      model: "Model",
      year: "Year",
      category: "Category",
      engine: "Engine",
      millage: "Mileage",
      color: "Color",
      transmission: "Transmission",
      fuel_type: "Fuel Type",
      drive_type: "Drive Type",
      cilinders: "Cylinders",
      gear_box: "Gear Box",
      location: "Location",
      vin: "VIN",
      doors: "Doors",
      airbags: "Airbags",
    }
  },
  ru: {
    header: {
      main: "Главная",
      about_us: "О нас",
      market: "Маркет",
      our_services: ["Наши", "Услуги"],
      contact: "Контакты",
      login: "Вход",
      logout: "Выход"
    },
    details: {
      share: "делиться",
      price: "цена",
      sold: "продано",
      for_sale: "в продаже",
      additional_info: "дополнительная информация",
      mark: "марка",
      model: "модель",
      year: "год",
      category: "категория",
      engine: "двигатель",
      millage: "пробег",
      color: "цвет",
      transmission: "коробка передач",
      fuel_type: "тип топлива",
      drive_type: "привод",
      cilinders: "цилиндры",
      gear_box: "коробка передач",
      location: "местоположение",
      vin: "VIN",
      doors: "двери",
      airbags: "подушки безопасности",
    },
    home_page: {
      banner_main_text: "Замени старое — на новое!",
      banner_small_text: "* Премиум",
      banner_main_slogan: "Перевозки из США по всему миру — быстро и по доступной цене",
      banner_subtext: "CAREXPRESS твой путь — к надежному автомобилю!",
      divided_banner_title: "",
      divided_banner_description: "Благодаря 20-летнему опыту, Carexpress является одним из крупнейших лицензированных автоимпортеров на Кавказе, что позволяет компании участвовать в ведущих автомобильных аукционах мира. <br /> Компания осуществляет импорт автомобилей, любой спецтехники, а также автозапчастей и аксессуаров из США, Канады и Европы.",
      divided_banner_description2: [`
        &nbsp&nbsp&nbspCarexpress, благодаря 20-летнему опыту, является одним из крупнейших лицензированных автоимпортеров на Кавказе, что позволяет ей участвовать в ведущих автомобильных аукционах мира.
        <br /> &nbsp&nbsp&nbspКомпания осуществляет импорт автомобилей, любой спецтехники, а также автозапчастей и аксессуаров из США, Европы и Канады.
        <br /> &nbsp&nbsp&nbspКлиенты Carexpress могут воспользоваться инновационными услугами, адаптированными под их интересы — как для разовой покупки авто, так и для ведения бизнеса по автоимпорту.
        <br /> &nbsp&nbsp&nbspС момента основания компания собрала высококвалифицированную команду, и сегодня насчитывает около 30 филиалов по всей Грузии и около 10 представительств за рубежом — в США, Кыргызстане и Объединённых Арабских Эмиратах.
        <br /> &nbsp&nbsp&nbspКоличество импортированных автомобилей Carexpress превысило 200 000 единиц.
      `, `
        <br /><br /> &nbsp&nbsp&nbspДля заинтересованных лиц мы предлагаем:
        <br />•	Неограниченный выбор на ведущих аукционах и дилерских рынках мира.
        <br />•	Покупку автомобиля по лучшей цене.
        <br />•	Безопасную и быструю транспортировку.
        <br />•	Гибкие и индивидуальные условия софинансирования на выбранный автомобиль.
        <br />•	Ответственность за повреждение автомобиля.
        <br />•	Доставку от места покупки до желаемого пункта.
        <br />•	Помощь в продаже автомобиля.
        <br />•	Терминальные услуги.
      `, `
        <br /><br /> &nbsp&nbsp&nbspС 2020 года, для повышения удобства и поддержки клиентов, компания открыла «АвтоМаркет» международного стандарта в городе Рустави, на территории автобазара.
        <br /> &nbsp&nbsp&nbspАвтоМаркет Carexpress уже стал удобным и практичным местом для многих клиентов — где объединены упрощённые процессы, комфортная среда и быстрый сервис в одном пространстве.
        <br /> &nbsp&nbsp&nbspКомпания также имеет собственный терминал, который постоянно обслуживает местных и региональных клиентов.
        <br /> &nbsp&nbsp&nbspCarexpress постоянно применяет накопленный опыт для улучшения логистических навыков и качества обслуживания. Поэтому мы всегда предлагаем клиентам быструю, качественную и безопасную транспортировку — как по суше, так и по морю.
        <br /> &nbsp&nbsp&nbspКомпания укомплектована командой, которая всегда готова помочь и повысить осведомлённость клиентов о текущих процессах, делая всё максимально прозрачным.
      `],
      divided_banner_bullet_1: "Морской транспорт",
      divided_banner_bullet_2: "Автомобили / Мотоциклы / ATV",
      divided_banner_bullet_3: "Тяжёлая техника",
      check_more: "Смотреть больше",
      what_we_do: "Что мы делаем?",
      services_title: ["Наши", "Услуги"],
      sea_cargo: "Морские перевозки",
      air_cargo: "Авиаперевозки",
      yacht: "Перевозка яхт",
      any_question: "Есть вопросы?",
      any_question_detailed: "",
      import_now: "Импортировать сейчас",
      call_us: "Позвоните нам",
      write_us: "Напишите нам",
      address: "Адрес",
      our_address: "Тбилиси, ул. Гурама Панжикидзе 22"
    },
    contact: {
      password: "Пароль",
      email_us: "Напишите нам",
      our_address: "Наш адрес",
      address: "Тбилиси, ул. Гурама Панжикидзе 22",
      opening_hours: "Часы работы",
      hours: "Пн - Пт / 10:00 - 19:00",
      call_us: "Позвоните нам",
      get_in_touch: "Свяжитесь с нами",
      location: "Местоположение",
      name: "Имя",
      name_placeholder: "Введите ваше имя",
      email: "Эл. почта",
      email_placeholder: "Введите вашу эл. почту",
      number: "Телефон",
      subject: "Тема",
      message: "Сообщение",
      number_placeholder: "Введите ваш номер телефона",
      subject_placeholder: "Введите тему",
      message_placeholder: "Введите сообщение",
      send_message: "Отправить сообщение",
      loading: "Отправка..."
    },
    cars:{
      title: "Машины",
      filterByMark: "Фильтр по бренду",
      filterByModel: "Фильтр по модели",
      searchByKeyword: "Поиск по ключевому слову",
    },
    footer: {
      footer_sublogo_slogan: "",
      footer_subscribe_description: "Хотите получать уведомления о наших услугах? Просто подпишитесь, и мы будем отправлять уведомления на вашу почту.",
      email: "Адрес эл. почты",
      rights: "©2025 Carexpress. Все права защищены.",
      quick_links: "Быстрые ссылки",
      subscribe: "Подписаться",
      subsubscribe: "Хотите получать уведомления о наших услугах? Просто подпишитесь, и мы будем отправлять уведомления на вашу почту."
    },
    login: {
      user: "Эл. почта",
      password: "Пароль"
    }
  },
  am: {
    details: {
      share: "կիսվել",
      price: "գին",
      sold: "վաճառված",
      for_sale: "վաճառքի համար",
      additional_info: "Լրացուցիչ տեղեկություններ",
      mark: "Մակնիշ",
      model: "մոդել",
      year: "տարեթիվ",
      category: "Կատեգորիա",
      engine: "Շարժիչ",
      millage: "վազք",
      color: "գույն",
      transmission: "կորուսատար տարածական",
      fuel_type: "բենզինի տեսակ",
      drive_type: "վարում",
      cilinders: "ցիլինդրներ",
      gear_box: "կորուսատար տարածական",
      location: "Գտնվելու վայրը",
      vin: "VIN",
      doors: "դարպասներ",
      airbags: "անվանական պայթյունակիցներ",
    },
    header: {
      main: "Գլխավոր",
      about_us: "Մեր մասին",
      market: "Շուկա",
      our_services: ["Մեր", "Սերվիսները"],
      contact: "Կապ",
      login: "Մուտք",
      logout: "Ելք"
    },
    cars: {
      title: "Մեքենաներ",
      filterByMark: "Ֆիլտր ըստ ապրանքանիշի",
      filterByModel: "Ֆիլտր ըստ մոդելի",
      searchByKeyword: "Որոնել հիմնաբառով"
    },
    home_page: {
      banner_main_text: "Փոխարինեք հինը՝ նորով!",
      banner_small_text: "* Պրեմիում",
      banner_main_slogan: "Ապահով առաքում ԱՄՆ-ից ամբողջ աշխարհ՝ ամենաարագ և լավագույն գնով",
      banner_subtext: "CAREXPRESS ճանապարհը՝ հուսալի ավտոմեքենայի համար!",
      divided_banner_title: "",
      divided_banner_description:
        "20 տարվա փորձով Carexpress-ը Կովկասում ամենամեծ լիցենզավորված ավտո ներմուծողներից մեկն է, ինչը թույլ է տալիս մասնակցել աշխարհի առաջատար ավտոմեքենաների աճուրդներին։ <br /> Компанияն ներմուծում է մեքենաներ, բոլոր տեսակի հատուկ տեխնիկա, ինչպես նաև ավտոմասեր և աքսեսուարներ ԱՄՆ-ից, Կանադայից և Եվրոպայից։",
      divided_banner_description2: [
        `
          &nbsp&nbsp&nbsp20 տարվա փորձով Carexpress-ը Կովկասում ամենամեծ լիցենզավորված ավտո ներմուծողներից մեկն է, ինչը թույլ է տալիս մասնակցել աշխարհի առաջատար ավտոմեքենաների աճուրդներին։
          <br /> &nbsp&nbsp&nbspКомпанияն ներմուծում է մեքենաներ, հատուկ տեխնիկա, ավտոմասեր և աքսեսուարներ ԱՄՆ-ից, Եվրոպայից և Կանադայից։
          <br /> &nbsp&nbsp&nbspCarexpress–ի հաճախորդները կարող են օգտվել հարմարեցված, նորարարական ծառայություններից՝ մեկանգամյա գնման կամ ավտո-բիզնեսով հետաքրքրվելու դեպքում։
          <br /> &nbsp&nbsp&nbspԸնկերությունը տարիների ընթացքում ձեւավորել է բարձրակարգ թիմ և այժմ ունի շուրջ 30 մասնաճյուղ ամբողջ Վրաստանում և մոտ 10 ներկայացուցիչ ԱՄՆ-ում, Ղրղզստանում և Արաբական Միացյալ Էմիրություններում։
          <br /> &nbsp&nbsp&nbspCarexpress–ի միջոցով ներմուծված մեքենաների թիվը արդեն անցել է 200,000–ը։
        `,
        `
          <br /><br /> &nbsp&nbsp&nbspՄենք առաջարկում ենք.
          <br />•	Անսահմանափակ ընտրություն՝ ամբողջ աշխարհի առաջատար աճուրդներից և դիլերական հարթակներից։
          <br />•	Ավտոմեքենայի գնում լավագույն գնով։
          <br />•	Ապահով և արագ տեղափոխում։
          <br />•	Ճկուն և անհատականացված համաֆինանսավորման տարբերակներ։
          <br />•	Վնասների պատասխանատվություն։
          <br />•	Տրանսպորտավորում գնման վայրից մինչ ձեր ընտրած հասցե։
          <br />•	Օգնություն մեքենայի վերավաճարման գործում։
          <br />•	Տերմինալային ծառայություններ։
        `,
        `
          <br /><br /> &nbsp&nbsp&nbsp2020 թվականից ընկերությունը բացել է միջազգային ստանդարտներին համապատասխան «Ավտոմարկետ» Ռուստավիում։
          <br /> &nbsp&nbsp&nbspCarexpress Ավտոմարկետը դարձել է շատ հաճախորդների համար հարմար և պրակտիկ վայր՝ արագ և պարզեցված պրոցեսներով։
          <br /> &nbsp&nbsp&nbspԸնկերությունն ունի նաեւ սեփական տերմինալ, որը մշտապես սպասարկում է տեղական և տարածաշրջանային հաճախորդներին։
          <br /> &nbsp&nbsp&nbspCarexpress-ը մշտապես բարելավում է իր լոգիստիկ ծառայությունները՝ ապահովելով բարձրորակ, արագ և անվտանգ փոխադրում ցամաքով և ծովով։
          <br /> &nbsp&nbsp&nbspՄեր թիմը միշտ պատրաստ է աջակցել հաճախորդներին եւ ապահովել գործընթացի ամբողջական թափանցիկությունը։
        `
      ],
      divided_banner_bullet_1: "Ծովային փոխադրում",
      divided_banner_bullet_2: "Մեքենաներ / Մոտոցիկլետներ / ATV",
      divided_banner_bullet_3: "Ծանր տեխնիկա",
      check_more: "Տեսնել ավելին",
      what_we_do: "Ի՞նչ ենք մենք անում",
      services_title: ["Մեր", "Սերվիսները"],
      sea_cargo: "Ծովային բեռներ",
      air_cargo: "Օդային բեռներ",
      yacht: "Յախտաների տեղափոխում",
      any_question: "Հարցեր ունե՞ք",
      any_question_detailed: "",
      import_now: "Ներմուծել հիմա",
      call_us: "Զանգահարել մեզ",
      write_us: "Գրել մեզ",
      address: "Հասցե",
      our_address: "Թբիլիսի, Գურամ Պանջիկიძեի 22"
    },
    contact: {
      password: "Գաղտնաբառ",
      email_us: "Գրել մեզ էլ. փոստով",
      our_address: "Մեր հասցեն է",
      address: "Թբիլիսի, Գուրամ Պանջիկիդզե 22",
      opening_hours: "Աշխատանքային ժամեր",
      hours: "Երկ - Ուրբ / 10:00 - 19:00",
      call_us: "Զանգահարեք մեզ",
      get_in_touch: "Կապ պահպանել",
      location: "Տեղադրություն",
      name: "Անուն",
      name_placeholder: "Գրեք ձեր անունը",
      email: "Էլ. Փոստ",
      email_placeholder: "Գրեք ձեր էլ. հասցեն",
      number: "Հեռախոսահամար",
      subject: "Թեմա",
      message: "Հաղորդագրություն",
      number_placeholder: "Գրեք ձեր հեռախոսահամարը",
      subject_placeholder: "Մուտքագրեք թեման",
      message_placeholder: "Գրեք ձեր հաղորդագրությունը",
      send_message: "Ուղարկել",
      loading: "Ուղարկվում է..."
    },
    footer: {
      footer_sublogo_slogan: "",
      footer_subscribe_description:
        "Ցանկանու՞մ եք ստանալ թարմացումներ մեր ծառայությունների մասին։ Պարզապես բաժանորդագրվեք, և մենք ձեզ կուղարկենք ծանուցումներ էլ.փոստով։",
      email: "Էլ․ հասցե",
      rights: "©2025 Carexpress. Բոլոր իրավունքները պաշտպանված են։",
      quick_links: "Արագ հղումներ",
      subscribe: "Բաժանորդագրվել",
      subsubscribe:
        "Ցանկանու՞մ եք ստանալ թարմացումներ մեր ծառայությունների մասին։ Պարզապես բաժանորդագրվեք՝ ծանուցումներ ստանալու համար։"
    },
    login: {
      user: "Էլ․ հասցե",
      password: "Գաղտնաբառ"
    }
  }
};


// Strings introduced by the market / car details / admin redesign live in
// languageExtra.js; merging them here keeps a single lookup: language[lang].x
// The merge goes one level deep so that, for example, the new `details` keys
// are added to the existing `details` section instead of replacing it.
Object.keys(languageExtra).forEach((code) => {
  const base = language[code] || {};
  const extra = languageExtra[code];

  Object.keys(extra).forEach((section) => {
    base[section] = {...(base[section] || {}), ...extra[section]};
  });

  language[code] = base;
});

export default language;